import { render, staticRenderFns } from "./wck.vue?vue&type=template&id=2d210802&scoped=true"
import script from "./wck.vue?vue&type=script&lang=js"
export * from "./wck.vue?vue&type=script&lang=js"
import style0 from "./wck.vue?vue&type=style&index=0&id=2d210802&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d210802",
  null
  
)

export default component.exports